import { createContext, useContext } from 'react';

// Exposes the conversation's send function to rendered tool output (e.g. the confirmation form's
// action button), so an in-thread action can post a follow-up user message — the same path the
// composer uses. `onSend(text, options?)`: `options.hiddenContext` attaches a structured payload the
// model sees but the chat never displays (e.g. a clicked suggestion's resolved references). Kept
// separate from AssistantContext (panel/layout state) and provided by Assistant, where the send
// handler lives. Value is `{ onSend }`; null outside a conversation.
const ConversationContext = createContext(null);

export default ConversationContext;

export function useConversation() {
  return useContext(ConversationContext);
}
